import { Button, Checkbox, DatePicker, Form, Input, Select, TimePicker } from 'antd';
import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import regex, { NOTIFIES, ACCOUNT_STATUS, USER_TYPE_OPTIONS } from '../../../constants/system.keys';
import { openMessage } from '../../../redux/actions';
import { toHoursAndMinutes } from '../../../untils/date';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const { Option } = Select;

const UpdateMemberComponent = ({
  namespace,
  data,
  onUpdate,
  setUserType,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const { detailRoleOfCustomer } = useSelector(
    (state) => state
  );
  const [, forceUpdate] = useState();
  const [requestId, setRequestId] = useState();



  useEffect(() => {
    forceUpdate({});
    return () => {
      form.resetFields();
    };
  }, [form]);

  useEffect(() => {
    if (namespace && data) {
      const {
        phonenumber,
        namespace,
        fullName,
        email,
        role,
        detailRoles,
        position,
        authMethod,
        enableWatermark,
        accountStatus,
        expireTime,
        username,
        password,
        externalUserId,
      } = data;
      const dataLiveTimeoutTemp =
        data?.accountConfiguration &&
          JSON.parse(data?.accountConfiguration)?.liveTimeout >= 0
          ? toHoursAndMinutes(
            JSON.parse(data?.accountConfiguration)?.liveTimeout
          )
          : null;
      form.setFieldsValue({
        username,
        password,
        authMethod,
        phonenumber,
        namespace,
        fullName,
        email,
        role,
        enableWatermark,
        expireTime: expireTime ? moment(expireTime) : null,
        accountStatus: accountStatus === ACCOUNT_STATUS.ACTIVE,
        detailRoles: detailRoles ? detailRoles?.split(';') : [],
        position: position ?? '',
        liveTimeout: dataLiveTimeoutTemp
          ? moment(
            `${dataLiveTimeoutTemp?.h}:${dataLiveTimeoutTemp?.m}`,
            'HH:mm'
          )
          : null,
        interactionTimeout: data?.accountConfiguration?.interactionTimeout ?? 0,
        disableMultiSession:
          data?.accountConfiguration?.disableMultiSession ?? true,
        externalUserId:
          externalUserId === null || externalUserId === undefined
            ? ''
            : String(externalUserId),
      });
      setUserType(role);
    }
  }, [data, form, namespace, setUserType]);
  const onFinish = (values) => {
    let current = new Date().getTime();
    setRequestId(current);
    return onUpdate(current, {
      ...values,
      externalUserId: values?.externalUserId?.toString().trim() || '',
      accountId: data?.accountId,
      username: data.username,
      disableMultiSession: values.disableMultiSession ? 0 : 1,
    });
  };

  const handleChangeUserType = (value) => {
    form.setFieldsValue({ detailRoles: [] });
    setUserType(value);
  };

  return (
    <div className="add-whitelist-ip-component">
      <Form form={form} {...layout} onFinish={onFinish} name="form_in_modal">


        <Form.Item
          name="phonenumber"
          label={t('Phone number')}
          rules={[
            {
              required: data?.phonenumber ? true : false,
              message: t('Please input the phone number!'),
            },
            {
              pattern: regex.isMobile,
              message: t('Please input the phone number!'),
            },
          ]}
        >
          <Input disabled placeholder={t('Phone number')} />
        </Form.Item>

        {/* <>
            <Form.Item
              name="username"
              label={t('Username')}
              rules={[
                {
                  required: true,
                  message: t('Please input the username!'),
                },
                {
                  pattern: regex.isUserNameApi,
                  message: t('Username is not valid!'),
                },
              ]}
            >
              <Input placeholder={t('Username')} />
            </Form.Item>

            <Form.Item
              name="password"
              label={t('Password')}
              rules={[
                {
                  required: true,
                  message: t('Please input the password!'),
                },
                {
                  pattern: regex.isPassword,
                  message: t('Password is not valid!'),   
                },
              ]}
            >
              <Input.Password placeholder={t('Password')} />
            </Form.Item>
          </> */}

        <Form.Item
          name="namespace"
          label={t('Namespace')}
          rules={[
            {
              required: true,
              message: t('Please input the namespace!'),
            },
            {
              pattern: regex.isurl,
              message: t('Please input the namespace!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input disabled placeholder={t('Namespace')} />
        </Form.Item>
        <Form.Item
          name="externalUserId"
          label={t('External Id')}
        >
          <Input placeholder={t('External Id')} />
        </Form.Item>
        <Form.Item
          name="fullName"
          label={t('Full name')}
          rules={[
            {
              required: true,
              message: t('Please input the name of member!'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input placeholder={t('Full name')} />
        </Form.Item>
        <Form.Item
          name="email"
          label={t('Email')}
          rules={[
            {
              required: true,
              message: t('Please input the email!'),
            },
            {
              type: 'email',
              message: t('Email address is not valid!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input placeholder={t('Email')} />
        </Form.Item>
        <Form.Item
          name="position"
          label={t('Position')}
          rules={[
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input placeholder={t('Position')} />
        </Form.Item>
        <Form.Item
          name="role"
          label={t('UserType')}
          rules={[
            {
              required: true,
              message: t('Please select the permission of member!'),
            },
          ]}
        >
          <Select
            placeholder={t('Permission of member')}
            onChange={handleChangeUserType}
          >
            {USER_TYPE_OPTIONS.map((item) => (
              <Option value={item.value}>{item.label}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="detailRoles"
          label={t('Role')}
        >
          <Select mode="multiple" placeholder={t('Role of member')}>
            {detailRoleOfCustomer?.map((role) => (
              <Option key={role} value={role}>
                {role?.replaceAll('-', ' ')}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="liveTimeout" label={t('Live Timeout')}>
          <TimePicker format="HH:mm" showNow={false} allowClear={false} />
        </Form.Item>
        <Form.Item name="interactionTimeout" label={t('Interaction Timeout')}>
          <Input
            placeholder={t('Interaction Timeout')}
            type="number"
            defaultValue={0}
            min={0}
          />
        </Form.Item>
        <Form.Item
          name="disableMultiSession"
          valuePropName="checked"
          label={t('Multi Session')}
        >
          <Checkbox></Checkbox>
        </Form.Item>
        <Form.Item
          label={t('Active Status')}
          name="accountStatus"
          valuePropName="checked">
          <Checkbox />
        </Form.Item>
        <Form.Item
          label={t('Expire Time')}
          name="expireTime">
          <DatePicker showTime />
        </Form.Item>
        <Form.Item
          label={t('Enable Watermark')}
          name="enableWatermark"
          valuePropName="checked">
          <Checkbox />
        </Form.Item>
        <div className="create-btn">
          <Form.Item shouldUpdate={true}>
            <Button type="primary" htmlType="submit">
              {t('Update')}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default UpdateMemberComponent;
